(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lbf-team-profile"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lbf-team-profile')) {
    customElements.define('lbf-team-profile', class extends HTMLElement {
      connectedCallback() {
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = [];
        this.backgroundVideo = this.querySelector('[data-background-video]');
        if (this.backgroundVideo) {
          this.backgroundVideo.defaultMuted = true;
          this.backgroundVideo.muted = true;
          this.backgroundVideo.playsInline = true;
        }
        this.stopAnimations = () => {
          if (this.backgroundVideo) {
            if (this.motionPreference.matches) {
              this.backgroundVideo.pause();
            } else {
              this.backgroundVideo.play().catch(() => {});
            }
          }
          if (this.motionPreference.matches) {
            this.observer?.disconnect();
            this.animations.forEach((animation) => animation.cancel());
          }
        };
        this.motionPreference.addEventListener('change', this.stopAnimations);
        this.stopAnimations();

        if (this.motionPreference.matches || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver((entries) => {
          let delay = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (this.motionPreference.matches || !entry.target.animate) return;

            this.animations.push(entry.target.animate([
              { opacity: 0, transform: 'translateY(24px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], {
              duration: 650,
              delay,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'backwards'
            }));
            delay += 120;
          });
        }, { threshold: 0.1 });

        this.querySelectorAll('[data-lbf-reveal]').forEach((element) => {
          this.observer.observe(element);
        });
      }

      disconnectedCallback() {
        this.backgroundVideo?.pause();
        this.observer?.disconnect();
        this.animations?.forEach((animation) => animation.cancel());
        this.motionPreference?.removeEventListener('change', this.stopAnimations);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["likha-curated-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('likha-curated-slider')) {
    customElements.define('likha-curated-slider', class extends HTMLElement {
      connectedCallback() {
        const carousel = this.querySelector('scroll-carousel');
        if (!carousel) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        let gesture = null;
        let dragged = false;

        // Touch uses native scrolling, preserving vertical page scrolling and momentum.
        carousel.addEventListener('pointerdown', (event) => {
          dragged = false;
          if (event.pointerType === 'touch' || event.button !== 0 || !event.isPrimary ||
              !window.matchMedia('(max-width: 999px)').matches) return;
          gesture = { id: event.pointerId, x: event.clientX, scroll: carousel.scrollLeft };
        }, options);

        carousel.addEventListener('pointermove', (event) => {
          if (!gesture || event.pointerId !== gesture.id) return;
          const distance = event.clientX - gesture.x;
          if (!dragged && Math.abs(distance) < 6) return;
          if (!dragged) {
            dragged = true;
            carousel.classList.add('is-dragging');
            carousel.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          carousel.scrollLeft = gesture.scroll - distance;
        }, options);

        const finish = (event) => {
          if (!gesture || event.pointerId !== gesture.id) return;
          gesture = null;
          carousel.classList.remove('is-dragging');
          if (carousel.hasPointerCapture(event.pointerId)) carousel.releasePointerCapture(event.pointerId);
        };
        window.addEventListener('pointerup', finish, options);
        window.addEventListener('pointercancel', finish, options);
        carousel.addEventListener('lostpointercapture', finish, options);
        carousel.addEventListener('dragstart', (event) => {
          if (gesture) event.preventDefault();
        }, options);
        carousel.addEventListener('click', (event) => {
          if (!dragged || event.detail === 0) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          dragged = false;
        }, { ...options, capture: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  if (!customElements.get('likha-curated-marquee')) {
    customElements.define('likha-curated-marquee', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.likha-curated-collection__track');
        if (!track) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        let gesture = null;
        let dragged = false;

        this.addEventListener('pointerdown', (event) => {
          dragged = false;
          if (event.button !== 0 || !event.isPrimary) return;
          const animation = track.getAnimations()[0];
          const distance = track.getBoundingClientRect().width / 2;
          if (!animation || !distance) return;
          this.classList.add('is-dragging');
          gesture = {
            id: event.pointerId,
            x: event.clientX,
            animation,
            time: Number(animation.currentTime || 0),
            duration: Number(animation.effect.getTiming().duration),
            distance,
            direction: getComputedStyle(this).direction === 'rtl' ? 1 : -1
          };
        }, options);

        this.addEventListener('pointermove', (event) => {
          if (!gesture || event.pointerId !== gesture.id) return;
          const delta = event.clientX - gesture.x;
          if (!dragged && Math.abs(delta) < 6) return;
          if (!dragged) {
            dragged = true;
            this.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          const time = gesture.time + gesture.direction * delta / gesture.distance * gesture.duration;
          gesture.animation.currentTime = ((time % gesture.duration) + gesture.duration) % gesture.duration;
        }, options);

        const finish = (event) => {
          if (!gesture || event.pointerId !== gesture.id) return;
          gesture = null;
          this.classList.remove('is-dragging');
          if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
        };
        window.addEventListener('pointerup', finish, options);
        window.addEventListener('pointercancel', finish, options);
        this.addEventListener('lostpointercapture', finish, options);
        this.addEventListener('dragstart', (event) => {
          if (gesture) event.preventDefault();
        }, options);
        this.addEventListener('click', (event) => {
          if (!dragged || event.detail === 0) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          dragged = false;
        }, { ...options, capture: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.classList.remove('is-dragging');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["likha-supporter-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('likha-supporter-stories')) {
    customElements.define('likha-supporter-stories', class extends HTMLElement {
      connectedCallback() {
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = [];
        this.stopAnimations = () => {
          if (!this.motionPreference.matches) return;
          this.observer?.disconnect();
          this.animations.forEach((animation) => animation.cancel());
        };
        this.motionPreference.addEventListener('change', this.stopAnimations);
        if (this.motionPreference.matches || !('IntersectionObserver' in window)) return;

        // Animate each group once as it enters view; content remains visible without JavaScript.
        this.observer = new IntersectionObserver((entries) => {
          let delay = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (this.motionPreference.matches || !entry.target.animate) return;
            this.animations.push(entry.target.animate([
              { opacity: 0, transform: 'translateY(24px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], {
              duration: 650,
              delay,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'backwards'
            }));
            delay += 120;
          });
        }, { threshold: 0.1 });

        this.querySelectorAll('[data-story-reveal]').forEach((element) => {
          this.observer.observe(element);
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.animations?.forEach((animation) => animation.cancel());
        this.motionPreference?.removeEventListener('change', this.stopAnimations);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
